import {BorderTable} from "../../../../../../components/border-table/border-table.jsx";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

export default function AgentClothes({ data }) {
    const clothes = data?.clothes ?? {};

    const clothesInfo = [
        {
            label: "Boina, bibico, capacete",
            value: clothes?.helmet ?? "",
        },
        {
            label: "Blusa, jaqueta, camisa, gandola",
            value: clothes?.jacket ?? "",
        },
        {
            label: "Colete balístico (número e tamanho)",
            value: clothes?.bulletproofVest ?? "",
        },
        {
            label: "Braçal",
            value: clothes?.militaryBracer ?? "",
        },
        {
            label: "Cotoveleira",
            value: clothes?.elbowPad ?? "",
        },
        {
            label: "Luva meio dedo",
            value: clothes?.halfFingerGlove ?? "",
        },
        {
            label: "Calça, bermuda",
            value: clothes?.pants ?? "",
        },
        {
            label: "Cinturão",
            value: clothes?.belt ?? "",
        },
        {
            label: "Joelheira",
            value: clothes?.kneeBrace ?? "",
        },
        {
            label: "Meia",
            value: clothes?.sock ?? "",
        },
        {
            label: "Conjunto de chuva",
            value: clothes?.rainSet ?? "",
        },
        {
            label: "Calçados (Bota, sapato)",
            value: clothes?.shoes ?? "",
        }
    ]

    return (
        <InfoGrid title={'Vestuário'} items={clothesInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]!'} contentClassName={'space-y-1'} className={'px-0!'}/>
    )
}